export const useScrollListenerMixin = (
  refScrollElement = 'scrollableElement',
  eventHandlers = {
    scrollUp: undefined,
    scrollDown: undefined
  },
  addEventListener = true
) => {
  const uppercaseRef = refScrollElement.charAt(0).toUpperCase() + refScrollElement.slice(1)

  const scrollEventHandler = `handle${uppercaseRef}`
  const settings = `scroll${uppercaseRef}`

  const add = `add${uppercaseRef}ScrollListener`
  const remove = `remove${uppercaseRef}ScrollListener`

  const setScrollY = `set${uppercaseRef}ScrollY`
  const hasScroll = `${refScrollElement}HasScroll`

  return {
    data () {
      return {
        [settings]: {
          scrolledY: [],
          disabled: false
        }
      }
    },
    computed: {
      [refScrollElement] () {
        return this.$refs[refScrollElement]
      }
    },
    mounted () {
      if (addEventListener) this[add]()
    },
    beforeDestroy () {
      if (addEventListener) this[remove]()
    },
    methods: {
      [add] () {
        this.$nextTick(() => {
          const scrollElement = this[refScrollElement]

          if (Array.isArray(scrollElement)) {
            for (const index in scrollElement) {
              const refElement = scrollElement[index]
              refElement.addEventListener('scroll', (event) => this[scrollEventHandler](refElement, event, index))
            }
          } else {
            scrollElement.addEventListener('scroll', (event) => this[scrollEventHandler](scrollElement, event))
          }
        })
      },
      [remove] () {
        this.$nextTick(() => {
          const scrollElement = this[refScrollElement]

          if (Array.isArray(scrollElement)) {
            for (const index in scrollElement) {
              const refElement = scrollElement[index]
              refElement.removeEventListener('scroll', (event) => this[scrollEventHandler](refElement, event, index))
            }
          } else {
            scrollElement.removeEventListener('scroll', (event) => this[scrollEventHandler](scrollElement, event))
          }
        })
      },
      [scrollEventHandler] (refElement, event, index = 0) {
        if (!this[settings].disabled) {
          const hasScrollY = refElement.scrollHeight > refElement.clientHeight

          if (hasScrollY) {
            const scrollPosition = refElement.scrollTop
            const containerHeight = refElement.clientHeight
            const contentHeight = refElement.scrollHeight

            const nearBottomThreshold = 100
            if (contentHeight - scrollPosition - containerHeight <= nearBottomThreshold) {
              if (eventHandlers.scrollDown) {
                this[eventHandlers.scrollDown](event, index)
              }
            }
            if (scrollPosition === 0) {
              if (eventHandlers.scrollUp) {
                this[eventHandlers.scrollUp](event, index)
              }
            }
          }
        }
      },
      [setScrollY] (y) {
        this[settings].disabled = true
        this[refScrollElement].scrollTop = y
        this[settings].disabled = false
      },
      [hasScroll] () {
        return this[refScrollElement].scrollHeight > this[refScrollElement].clientHeight
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins/useScrollListenerMixin.js